<template>
  <router-link class="auction-card" :to="'/auction/' + id">
    <div v-if="category == 'Mens'" class="avatar avatar-mens"></div>
    <div v-if="category == 'Womens'" class="avatar avatar-womens"></div>
    <div class="details">
      <div class="auction-name">{{ name }}</div>
      <div>{{ category }} seed {{ seed }}</div>
      <div v-if="currentBid">Current bid: ${{ currentBid }}</div>
      <div v-if="!currentBid">No bids yet</div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    name: String,
    category: String,
    id: String,
    seed: Number,
    currentBid: Number,
  },
};
</script>

<style scoped>
.auction-card {
  display: flex;
  align-items: center;
  background: #ffffff;
  color: #0e3f70;
  border-radius: 6px;
  padding: 16px;
  text-align: center;
  margin-bottom: 8px;
}

.details {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.auction-name {
  font-weight: bold;
}

a {
  text-decoration: none;
}

.avatar {
  width: 72px;
  height: 72px;
  background: #f7f7f7;
  border-radius: 50%;
  margin-right: 16px;
}

.avatar-mens {
  background: url("/avatar-mens.png");
  background-size: cover;
}

.avatar-womens {
  background: url("/avatar-womens.png");
  background-size: cover;
}
</style>